import "./modules/global";
import Splide from "@splidejs/splide";

window.addEventListener("load", () => {
	const faqQuestions = document.querySelectorAll(".faq-question");
	faqQuestions.forEach((question) => {
		question.addEventListener("click", () => {
			question.querySelector("h3").classList.toggle("active");
			question.querySelector("svg").classList.toggle("active");
			question.querySelector("p").classList.toggle("show");
			question.classList.toggle("active");
		});
	});

	const rowBoxesSliderEl = document.querySelector(".row-boxes-slider");
	if (!rowBoxesSliderEl) return;

	new Splide(rowBoxesSliderEl, {
		type: "loop",
		perPage: 3,
		perMove: 1,
		gap: "30px",
		arrows: false,
		pagination: false,
		autoplay: false,
		interval: 4000,
		speed: 800,
		pauseOnHover: true,
		pauseOnFocus: true,
		breakpoints: {
			1199: {
				perPage: 2,
				gap: "30px",
			},
			640: {
				perPage: 1,
				gap: "16px",
			},
		},
	}).mount();
});
